// extracted by mini-css-extract-plugin
export var label = "_5b-1";
export var reminder = "_5b-0";